import { render, staticRenderFns } from "./TopicForm.vue?vue&type=template&id=0e0f5998&scoped=true"
import script from "./TopicForm.vue?vue&type=script&lang=js"
export * from "./TopicForm.vue?vue&type=script&lang=js"
import style0 from "./TopicForm.vue?vue&type=style&index=0&id=0e0f5998&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0f5998",
  null
  
)

export default component.exports